import { createSlice } from '@reduxjs/toolkit';
import { storeSelected } from '@/shared/lib/redux/actions';

export interface StoreState {
  currentStoreId: string | null;
}

const initialState: StoreState = {
  currentStoreId: null,
};

const storeContextSlice = createSlice({
  name: 'storeContext',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(storeSelected, (state, action) => {
      state.currentStoreId = action.payload;
    });
  },
});

export const storeContextReducer = storeContextSlice.reducer;
